
import React, { useState } from 'react';
import './DragDropBox.css';

const DragDropBox = () => {
  const [dragActive, setDragActive] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (event) => setImageSrc(event.target.result);
      reader.readAsDataURL(file);
    } else {
      alert('Please drop a valid image file.');
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (event) => setImageSrc(event.target.result);
      reader.readAsDataURL(file);
    } else {
      alert('Please select a valid image file.');
    }
  };

  return (
    <div>
      <div
        className={`drag-drop-box ${dragActive ? 'drag-active' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <p>Drag and drop an image here, or click to select a file</p>
        <input
          type="file"
          className="file-input"
          accept="image/*"
          onChange={handleFileChange}
        />
      </div>
      {imageSrc && <img src={imageSrc} alt="Preview" className="image-preview" />}
    </div>
  );
};

export default DragDropBox;
